import { cn } from "../../lib/utils";
import { statusBadgeClass, statusLabel } from "./utils";
import type { ChangeRequestStatus } from "@/services/APIs/PtsChangeRequestService";

export function ChangeRequestStatusBadge({
  status,
}: {
  status?: ChangeRequestStatus | null;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
        statusBadgeClass(status)
      )}
    >
      {statusLabel(status)}
    </span>
  );
}
